import { LogicalDeleteDTO } from '../basic/logicalDeleteDTO';
import { CollaboratoreDTO } from '../domain/collaboratore';
import { TenantDTO } from '../domain/tenant';
import { SondaggioDTO, SondaggioOptionDTO } from './sondaggio';

export class SondaggioRispostaDTO {
    collaboratore: CollaboratoreDTO;
    sondaggio: SondaggioDTO;
    risposte: SondaggioRispostaOptionDTO[];
}

export class SondaggioRispostaOptionDTO extends LogicalDeleteDTO {
    id: number;
    tenant: TenantDTO;
    collaboratore: CollaboratoreDTO;
    sondaggioOption: SondaggioOptionDTO;
}